import React, { useState, useEffect, useContext, useCallback, useMemo} from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from "moment";
import MachineCoinAlgoritmForm from '../../components/Modals/MachineCoinAlgoritmForm'
import { NavigationContext } from '../../context/navigation-context'
import useForm from '../../hooks/form-hook'
import EvadtsCompareModal from '../../components/Modals/EvadtsCompareModal'
import EvadtsCompareResultModal from '../../components/Modals/EvadtsCompareResultModal';
import SearchFilter from '../../components/Filter/SearchFilter';

const KPS = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()
  const { form, openForm, closeForm } = useForm()
  const { setHeaderData } = useContext(NavigationContext)

  const [KPS, setKPS] = useState([])

  const [evadtsModal, setEvadtsModal] = useState({ show: false, visitId: null, machineId: null, headerLeft: "" });
  const [evadtsResult, setEvadtsResult] = useState({ show: false, rows: [], visitId: null, selectedLabel: '' });

  const defaultAdditionalFilter = {kp: '', userAndDate: '', machineAndModel: '', expected: '', recalculated: '', bag: '', coinAlgoritm: '', evadts: ''};
  const [additionalFilter, setAdditionalFilter] = useState(defaultAdditionalFilter);

  const reportList = [
    { reportId: 7, reportColor: "outline-primary"},
    { reportId: 15, reportColor: "primary" },
    { reportId: 24, reportColor: "danger" },
    { reportId: 92, reportColor: "success" },
    { reportId: 93, reportColor: "dark" },
  ].filter(Boolean);

  const openEvadtsModalFn = useCallback((visitId, machineId, currentData) => {
    setEvadtsModal(prev => ({
      ...prev,
      show: true,
      visitId,
      machineId,
      currentData
    }));
  }, []);

  const closeEvadtsModal = useCallback(() => {setEvadtsModal({ show: false, visitId: null, machineId: null, currentData: null })}, []);
  const openEvadtsResult = ({ rows, visitId, selectedLabel, headerLeft, headerRight }) => setEvadtsResult({ show: true, rows, visitId, selectedLabel, headerLeft, headerRight });
  const closeEvadtsResult = () => setEvadtsResult({ show: false, rows: [], visitId: null, selectedLabel: '' });

  const defaultFilter = {
    name: "kps",
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    isRecalculated: "null",
    machineId: null,
    machineName: "",
    userId: null,
    userName: "",
    dateTimeRangeFrom: moment().startOf("day").format('YYYY-MM-DDTHH:mm:ss'),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    machineTags: { id: [], name: [] }
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({});

  const parseThreeState = (val) => {
    if (val === true || val === "true") return true;
    if (val === false || val === "false") return false;
    return null;
  };

  const getMachineIdsByTags = (machineTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "tags/getMachineIdsByTags",
        { method: "POST", hideNotification: true, data: { machineTagIds } },
        (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
        (err) => reject(err)
      );
    });
  };
  
  const getKPS = async (f) => {
    let machineIds = "[]";
    if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)} 
    if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr);}
    fetchMssqlApi('kps', {
      method: 'POST',
      hideNotification: true,
      data: {
        fromCreateDateTime: f?.dateTimeRangeFrom,
        toCreateDateTime: f?.dateTimeRangeTo,
        machineIds,
        createUserId: f?.userId ?? null,
        isRecalculated: parseThreeState(f?.isRecalculated),
      }
    }, (res) => setKPS(res || [])
    );
  };

  useEffect(() => {
    setHeaderData({ text: TRL_Pack.kp.kps });
  }, []);

  const handleCoinValueChange = evt => {
    const { id, value } = evt.target

    if (value) {
      let coinsValue = value.replace(',', '.');

      if (!isNaN(coinsValue)) {
        let postData = {
          coinsValue: coinsValue,
          machineCoinInventoryId: id
        }

        fetchMssqlApi('kp-update-coins-value', {
          method: 'POST',
          hideNotification: false,
          data: postData
        })
      }
    }
  }

  const showBagColumn = KPS.some(entry => String(entry.B).trim() !== '');

  const filtered = useMemo(() => {
    return KPS?.filter(item =>
      (additionalFilter.kp === '' || `${item.KP || ''}`.toLowerCase().includes(additionalFilter.kp.toLowerCase())) &&
      (additionalFilter.userAndDate === '' || `${item.CreatedBy || ''} ${item.LocalCurrentCreateDateTime || ''}`.toLowerCase().includes(additionalFilter.userAndDate.toLowerCase())) &&
      (additionalFilter.machineAndModel === '' || `${item.MachineFullName || ''} ${item.MachineType || ''}`.toLowerCase().includes(additionalFilter.machineAndModel.toLowerCase())) &&
      (additionalFilter.expected === '' || `${item.ExpectedCoinsValue || ''}`.toLowerCase().includes(additionalFilter.expected.toLowerCase())) &&
      (additionalFilter.recalculated === '' || `${item.CurrentCoinsValue || ''}`.toLowerCase().includes(additionalFilter.recalculated.toLowerCase())) &&
      (additionalFilter.bag === '' || `${item.BagName || ''}`.toLowerCase().includes(additionalFilter.bag.toLowerCase())) &&
      (additionalFilter.coinAlgoritm === '' || `${
        Number(item.DefaultCoinAlgoritmId) === 1 ? 'Suma sprzedaży' :
        Number(item.DefaultCoinAlgoritmId) === 2 ? 'Liczniki całkowite' :
        Number(item.DefaultCoinAlgoritmId) === 3 ? 'Monety wrzucone do skrzynki' :
        Number(item.DefaultCoinAlgoritmId) === 4 ? 'Sprzedaż gotówkowa' :
        Number(item.DefaultCoinAlgoritmId) === 5 ? 'Notowania liczników ilość średnia cena' :
        Number(item.DefaultCoinAlgoritmId) === 6 ? 'Notowania liczników wartość' :
        Number(item.DefaultCoinAlgoritmId) === 7 ? 'Sprzedaż z paragonów' :
        Number(item.DefaultCoinAlgoritmId) === 8 ? 'Banknoty' :
        'BRAK'
      }`.toLowerCase().includes(additionalFilter.coinAlgoritm.toLowerCase())) &&
      (additionalFilter.evadts === '' || `${item.HasEVADTS || ''}`.toLowerCase().includes(additionalFilter.evadts.toLowerCase()))
    ) ?? [];
  }, [KPS, additionalFilter]);

  return (
    <>
      <SearchFilter
        filterName="kps"
        defaultFilter={defaultFilter}
        reportList={reportList}
        onFilterChange={(f) => setFilter(f)}
        onSettingsChange={(s) => {setSettingsFilter(s)}}
        search={getKPS}
        totalCount={KPS.length}
        defaultAdditionalFilter={defaultAdditionalFilter}
        additionalFilter={additionalFilter}
        onAdditionalFilterChange={(af) => setAdditionalFilter(af)}
        forNow
      />
      <div style={{maxHeight: "calc(100vh - 120px)", overflowY: "auto"}}>
      {KPS.length ? (
        <table className="table table-striped custom-scroll" >
          <colgroup>
            <col style={{ minWidth: "145px", width: "145px" }}/>
            <col style={{ minWidth: "180px"}}/>
            <col style={{ minWidth: "300px"}}/>
            <col style={{ minWidth: "120px", width: "120px" }}/>
            <col style={{ minWidth: "180px", width: "180px" }}/>
            <col style={{ minWidth: "120px", width: "120px" }}/>
            {showBagColumn && <col style={{ minWidth: "80px", width: "80px" }}/>}
            <col style={{ minWidth: "250px", width: "250px" }}/>
            <col style={{ minWidth: "80px", width: "80px" }}/>
          </colgroup>
          <thead>
            <tr className="text-center headers-color">
              <th className='align-middle p-1 m-1'>
                KP<br/>
                <input type="text" value={additionalFilter.kp || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, kp: value}))} className={`additional-filter-input ${additionalFilter.kp ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                Serwisant (Zapis)<br/>
                <input type="text" value={additionalFilter.userAndDate || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, userAndDate: value}))} className={`additional-filter-input ${additionalFilter.userAndDate ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                Automat, Model<br/>
                <input type="text" value={additionalFilter.machineAndModel || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, machineAndModel: value}))} className={`additional-filter-input ${additionalFilter.machineAndModel ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                Oczekiwana<br/>
                <input type="text" value={additionalFilter.expected || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, expected: value}))} className={`additional-filter-input ${additionalFilter.expected ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className="align-middle p-1 m-1">
                Banknoty i monety wg EVADTS
              </th>
              <th className='align-middle p-1 m-1'>
                Przeliczona<br/>
                <input type="text" value={additionalFilter.recalculated || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, recalculated: value}))} className={`additional-filter-input ${additionalFilter.recalculated ? "additional-filter-input-active" : ""}`}/>
              </th>
              {showBagColumn && <th className='align-middle p-1 m-1'>
                Worek<br/>
                <input type="text" value={additionalFilter.bag || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, bag: value}))} className={`additional-filter-input ${additionalFilter.bag ? "additional-filter-input-active" : ""}`}/>
              </th>}
              <th className='align-middle p-1 m-1'>
                Sposób wyliczania<br/>
                <input type="text" value={additionalFilter.coinAlgoritm || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, coinAlgoritm: value}))} className={`additional-filter-input ${additionalFilter.coinAlgoritm ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                EVADTS<br/>
                <div>
                  <span className='badge badge-success mr-1' style={{ cursor: "pointer", userSelect: "none" }} onClick={() => setAdditionalFilter(prev => ({...prev, evadts: prev.evadts === "TAK" ? "" : "TAK"}))}>TAK</span>
                  <span className='badge badge-danger' style={{ cursor: "pointer", userSelect: "none" }} onClick={() => setAdditionalFilter(prev => ({...prev, evadts: prev.evadts === "NIE" ? "" : "NIE"}))}>NIE</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {filtered.slice((filter.page - 1) * settingsFilter.rowsPerPage, filter.page * settingsFilter.rowsPerPage).map((entry) => (
              <tr key={entry.MachineCoinInventoryId}>
                <td className="p-1 m-0 text-center">
                  <div className="btn text-nowrap btn-sm btn-outline-success">{entry.KP}</div>
                </td>
                <td className="p-1 m-0 text-center">
                  {entry.CreatedBy}
                  <br/>{entry?.LocalCurrentCreateDateTime}
                </td>
                <td className="p-1 m-0 text-center">
                  <Link to={`/machine/${entry.MachineId}`} className="btn btn-sm btn-outline-secondary py-0 my-0">{entry.MachineFullName} ({entry.MachineType})</Link>
                </td>
                <td className="p-1 m-0 text-center">
                    {String(Number(entry.ExpectedCoinsValue).toFixed(2)).replace('.', ',')} zł
                </td>             
                <td className="p-1 text-center align-middle">
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '3px', maxWidth: '160px', margin: 'auto' }}>
                    {[
                      ['Monety', entry.D, 'coins', '#fff4d9', '#b67b00'],
                      ['Banknoty', entry.O, 'money-bill-wave', '#e2f5eb', '#168454']
                    ].map(([name, value, icon, bg, color]) => (
                      <div key={name} className="d-flex align-items-center justify-content-between rounded" style={{ gridColumn: '1 / -1', background: bg, padding: '4px 6px', gap: '4px', whiteSpace: 'nowrap' }}>
                        <span className="d-flex align-items-center" style={{ gap: '5px', fontSize: '10px', fontWeight: 600 }}>
                          <i className={`fas fa-${icon}`} style={{ color, fontSize: '11px' }} />{name}
                        </span>
                        <strong style={{ color, fontSize: '10px' }}>{Number(value ?? 0).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} zł</strong>
                      </div>
                    ))}
                    {[
                      [10, entry.Banknoty10zl, 'success'],
                      [20, entry.Banknoty20zl, 'info'],
                      [50, entry.Banknoty50zl, 'primary'],
                      [100, entry.Banknoty100zl, 'warning']
                    ].filter(([, count]) => Number(count) > 0).map(([nominal, count, color]) => (
                      <div key={nominal} className="d-flex align-items-center justify-content-center bg-white border rounded" style={{ padding: '3px 4px', gap: '4px', whiteSpace: 'nowrap', minWidth: 0 }}>
                        <i className={`fas fa-money-bill-wave text-${color}`} style={{ fontSize: '11px' }} />
                        <strong style={{ fontSize: '10px' }}>{nominal}</strong>
                        <span className={`badge badge-${color}`} style={{ fontSize: '9px', padding: '2px 3px' }}>×{Number(count)}</span>
                      </div>
                    ))}
                  </div>
                </td>
                <td className="p-1 m-0 text-center">
                    <input type="number" className="text-center form-control form-control-sm" onBlur={handleCoinValueChange} tabIndex="1" min="0" max="10000" id={entry.MachineCoinInventoryId} defaultValue={entry?.CurrentCoinsValue} pattern='[0-9],' step={0.01}></input>
                </td>
                {showBagColumn &&
                <td className="p-1 m-0 text-center">
                  <div className='d-flex flex-column justify-content-center align-items-center'>
                    {entry.B}
                  </div>
                </td>
                }
                <td className="p-1 m-0 text-center">
                  {entry.DefaultCoinAlgoritmId === 1 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-primary">Suma sprzedaży</button>)}
                  {entry.DefaultCoinAlgoritmId === 2 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-secondary">Liczniki całkowite</button>)}
                  {entry.DefaultCoinAlgoritmId === 3 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-danger">Monety wrzucone do skrzynki</button>)}
                  {entry.DefaultCoinAlgoritmId === 4 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-warning">Sprzedaż gotówkowa</button>)}
                  {entry.DefaultCoinAlgoritmId === 5 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-info">Notowanania liczników <br /> (ilość * średnia cena)</button>)}
                  {entry.DefaultCoinAlgoritmId === 6 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-dark">Notowania liczników (wartość)</button>)}
                  {entry.DefaultCoinAlgoritmId === 7 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-success">Sprzedaż z paragonów</button>)}
                  {entry.DefaultCoinAlgoritmId === 8 && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-primary">Banknoty</button>)}
                  {!+entry.DefaultCoinAlgoritmId && (<button onClick={openForm(entry)} className="btn btn-sm btn-outline-danger">BRAK!</button>)}
                </td>
                <td className="p-1 m-0 text-center">
                  <button className={(entry.HasEVADTS === "TAK") ? "btn btn-outline-success btn-sm text-center" : "btn btn-outline-danger btn-sm text-center"} onClick={() => openEvadtsModalFn(entry.MachineCoinInventoryId, entry.MachineId, {FullName: entry.KP || `Wizyta #${entry.MachineCoinInventoryId}`, CreateDateTimeStr: entry.LocalCurrentCreateDateTime, UserName: entry.CreatedBy })}>
                  <i className="fas fa-search align-middle"/>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoResults />
      )
      }
      {form && (
        <MachineCoinAlgoritmForm
          data={form}
          handleClose={closeForm}
          search={() => getKPS(filter)}
        />
      )}
      {evadtsModal.show && (
        <EvadtsCompareModal
          show={evadtsModal.show}
          onHide={closeEvadtsModal}
          visitId={evadtsModal.visitId}
          machineId={evadtsModal.machineId}
          currentData={evadtsModal.currentData}
          onCompared={openEvadtsResult}
        />
      )}
      {evadtsResult.show && (
        <EvadtsCompareResultModal
          show={evadtsResult.show}
          onHide={closeEvadtsResult}
          rows={evadtsResult.rows}
          visitId={evadtsResult.visitId}
          selectedLabel={evadtsResult.selectedLabel}
          headerLeft={evadtsResult.headerLeft}
          headerRight={evadtsResult.headerRight}
        />
      )}
      </div>
    </>
  );
}

export default KPS;
